import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
} from '@mui/material';

// Import content from existing pages (we'll embed them as tabs)
import DashboardContent from './tabs/DashboardContent';
import AnalyticsContent from './tabs/AnalyticsContent';
import ReportsContent from './tabs/ReportsContent';

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`overview-tabpanel-${index}`}
    aria-labelledby={`overview-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
  </div>
);

const Overview = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      {/* Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleTabChange}>
          <Tab label="Dashboard" />
          <Tab label="Analytics" />
          <Tab label="Reports" />
        </Tabs>
      </Box>

      {/* Dashboard Tab */}
      <TabPanel value={tabValue} index={0}>
        <DashboardContent />
      </TabPanel>

      {/* Analytics Tab */}
      <TabPanel value={tabValue} index={1}>
        <AnalyticsContent />
      </TabPanel>

      {/* Reports Tab */}
      <TabPanel value={tabValue} index={2}>
        <ReportsContent />
      </TabPanel>
    </Box>
  );
};

export default Overview;

